module.exports = __webpack_public_path__ + "img/logo.0583cf08.png";